import { faCheck, faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import GradientBtn from "../../GradientBtn";
import PharmaDummyImage from "src/assets/images/website-images/dummy-pharmaproduct-image.png";
import { Skeleton } from "@mui/material"; // MUI Skeleton ke liye import
import { ImageBaseUrl } from "src/lib/constans";
import FavoriteCoponent from "src/Components/GlobalComponents/FavoriteCoponent";
import PriceView from "src/Components/GlobalComponents/PriceView";
import AddCartButton from "src/Components/GlobalComponents/AddCartButton";
import AddCartComponent from "src/Components/Customer/ProductsAndServicesComponents/AddCartComponent";
import HowManytDealOFF from "src/Components/GlobalComponents/HowManytDealOFF";
import { useNavigate } from "react-router-dom";

interface IProps {
  skeleton?: boolean;
  id?: string;
  data?: any;
}

const HealthPackageCard = ({ skeleton = false, id, data }: IProps) => {
  const navigate = useNavigate();
  let Tests = [
    "Blood Test",
    "Liver Function Test",
    "Thyroid Function Test",
    "Cholesterol Test",
    "Blood Sugar Test",
    "Blood Pressure Test",
  ];

  if (skeleton) {
    return (
      <div className="w-full bg-white shadow-[0px_0px_7px_#00000029] border border-[#619B97] rounded-[15px]">
        <div className="w-full aspect-[1/0.7] rounded-tr-[15px] rounded-tl-[15px] relative bg-[#F6F6F6]">
          <Skeleton
            variant="rectangular"
            width="100%"
            height="100%"
            // sx={{ borderRadius: "15px 15px 0 0" }}
          />
          <div className="absolute top-0 left-0 w-[100%] h-fit p-2 flex justify-between">
            <Skeleton variant="rectangular" width={40} height={40} />
            <Skeleton variant="circular" width={35} height={35} />
          </div>
          <div className="absolute bottom-0 left-0 w-[100%] h-fit px-2 flex items-center pb-1 justify-between">
            <Skeleton variant="rectangular" width={50} height={24} />
          </div>
        </div>
        <div className="w-full p-4 flex flex-col justify-between gap-3 min-h-[220px]">
          <div className="flex flex-col gap-2">
            <Skeleton variant="rectangular" width={150} height={24} />
            <div className="flex flex-col gap-1">
              {Array.from({ length: 4 }).map((_, index) => (
                <div key={`${index}-skeleton-health-package-card`} className="flex items-center gap-2">
                  <Skeleton variant="circular" width={17} height={17} />
                  <Skeleton variant="text" width="80%" height={20} />
                </div>
              ))}
            </div>
          </div>
          <div className="flex w-full flex-col">
            <div className="flex items-center gap-2">
              <Skeleton variant="text" width={60} height={24} />
              <Skeleton variant="text" width={50} height={20} />
            </div>
            <Skeleton variant="rectangular" width={120} height={40} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      id={id || ""}
      className="w-full !h-full cursor-pointer bg-white shadow-[0px_0px_7px_#00000029] flex flex-col border border-[#619B97] product-card-radius"
      onClick={() => {
        navigate(`/diagnostic-product/package/${data?._id || ""}/view`);
      }}
    >
      <div className="w-full aspect-[1/0.7] product-card-radius-image overflow-hidden relative bg-[#F6F6F6]">
        <div className="absolute top-0 left-0 w-[100%] h-fit p-2 flex justify-between">
          <HowManytDealOFF regularPrice={data?.regularPrice} salePrice={data?.salePrice} isDetail={true} />
          <FavoriteCoponent
            liked={data?.isLiked}
            id={data?._id}
            category="package"
          />
        </div>
        <img
          src={ data?.image || PharmaDummyImage}
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute bottom-0 left-0 w-[100%] h-fit px-2 flex items-center pb-1 justify-between">
          <div className="px-2 py-1 font-size-12px rounded-xl bg-[#F59E0B] text-white flex items-center justify-center gap-1">
            <FontAwesomeIcon icon={faStar} />
            <span className="font-Lexend-Regular">{(data?.averageRating ? data?.averageRating : 0).toFixed(1)}</span>
          </div>
        </div>
      </div>
      <div className="w-full 2xl:p-4 p-2 flex flex-col flex-1 justify-between gap-3 h-[calc(100%-180px)] 2xl:min-h-[220px] xl:min-h-[200px] min-h-[195px]">
        <div className="flex flex-col 2xl:gap-2 gap-1">
          <p className="font-Lexend-Regular font-size-18px health-package-main-text-color">
            {data?.name || "Title Not Found"}
          </p>
          <div className="flex flex-col gap-1">
            {data?.testDetails?.slice(0, 4).map((item: any, index: number) => (
              <div className="flex items-center 2xl:gap-2 gap-1">
                <div className="w-fit min-w-[14px] xl:min-w-[17px] min-h-[14px] xl:min-h-[17px] rounded-full text-white theme-bg-green-dark flex items-center justify-center">
                  <FontAwesomeIcon icon={faCheck} className="font-size-10px" />
                </div>{" "}
                <p
                  key={`${index}-health-package-card`}
                  className="font-size-14px font-Poppins-Regular line-clamp-1 health-package-test-names-color"
                >
                  {item?.productName || "Test Not Found" || item?.testName}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className="flex w-full flex-col">
          <PriceView regularPrice={data?.regularPrice} salePrice={data?.salePrice} />
          <div className="flex 2xl:mt-2 mt-1">
            <AddCartComponent
              type="diagnostic"
              productId={data?._id}
              quantity={1}
              itemType="package"
              stockQuantity={data?.quantity}
              prescriptionRequired={false}
              textBtn
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HealthPackageCard;
